import customSelect from 'custom-select'

export default {
  name: 'custom-select',

  ui: {
    select: '[js-custom-select-select]',
    labelSelectMobile: '[js-label-select-mobile]',
  },

  events: [
    {
      on: 'change',
      handle (e) {
        this.ui.labelSelectMobile.innerHTML = this.ui.select[this.ui.select.selectedIndex].text
      },
    },
  ],

  componentDidMount () {
    customSelect(this.ui.select, {
      containerClass: 'custom-select-container',
      openerClass: 'custom-select-opener',
      panelClass: 'custom-select-panel',
      optionClass: 'custom-select-option',
      optgroupClass: 'custom-select-optgroup',
      isSelectedClass: 'is-selected',
      hasFocusClass: 'has-focus',
      isDisabledClass: 'is-disabled',
      isOpenClass: 'is-open',
    })

    const iconContainer = document.createElement('div')
    iconContainer.innerHTML = `
      <div class="custom-select-icon-wrapper">
        <svg class="custom-select-icon icon icon--gray">
          <use href="#icon-arrow-down" xlink:href="#icon-arrow-down"></use>
        </svg>
      </div>
    `

    this.ui.select.parentNode.appendChild(iconContainer.firstElementChild)

    // contact page w/ params
    if (this.props && this.props.page === 'contact') {
      this.ui.labelSelectMobile.innerHTML = this.ui.select[this.ui.select.selectedIndex].text
    }

    if (this.props && this.props.type === 'menu') {
      this.ui.select.addEventListener('change', () => {
        window.location.href = this.ui.select.value
      })
    }
  },
}
